import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';

import * as styles from './a11y.module.scss';

interface A11yProps extends WithTranslation<'A11y'> {
  title: string;
}

const A11y = ({title, t}: A11yProps) => {
  return (
    <div className={styles.a11y} role="status" aria-live="polite">
      {t('navigationAnnouncement', {title})}
    </div>
  );
};

export default withTranslation('A11y')(A11y);
